import { VoucherType } from '@prisma/client';

const currency = 'CHF';
// we will have values of 10 and 20 possibly...
export const VOUCHER_VALUE = 10;

export const VOUCHER_AMOUNTS = {
  DEFAULT: `${VOUCHER_VALUE} ${currency}`,
  SPECIAL: `${VOUCHER_VALUE * 2} ${currency}`,
} as const;

export const voucherAmountLabel = (value: number) => `${value} ${currency}`;

// A BDM2 payout is split across denominations (35 CHF = 3x10 + 1x5), so a code's
// value has to come from its type. Cash is staff-settled and never shown to the
// participant, hence no label.
export const VOUCHER_TYPE_AMOUNTS: Record<VoucherType, string | null> = {
  [VoucherType.TenEuros]: voucherAmountLabel(10),
  [VoucherType.FiveEuros]: voucherAmountLabel(5),
  [VoucherType.Cash]: null,
};

export const COLORS = {
  SUCCESS: '#3D7F53',
  NEUTRAL: '#4A4A48',
  PRIMARY: '#1570CB',
  TEXT_PRIMARY: '#202020',
  WHITE: '#FFFFFF',
} as const;

export const ICON_STYLES = {
  small: { width: '18px', height: '18px', lineHeight: '16px' },
  medium: { height: 20 },
} as const;
